import { IOption } from 'types';

export const createOptionsWithAll = (items: IOption[]): { label: string; value: string }[] => [
	{ label: 'All', value: '' },
	...(items?.filter((item) => item.name !== 'Resolved')?.map((item) => ({
		label: item.name ?? '',
		value: item.value ?? '',
	})) || []),
];